import { reactive } from "vue";
import DealerKit from "../../js/api";
const state = reactive({
    isLoading: false,
    chartOfAccounts: undefined
});
function useLedgerStore() {
    async function getLedgerAccounts(type) {
        if (!state.isLoading && state.chartOfAccounts === undefined) {
            state.isLoading = true;
            await DealerKit.accounting.getLedgerAccounts().then(response => {
                state.chartOfAccounts = response.data.data;
            }).finally(() => {
                state.isLoading = false;
            });
        }
        await new Promise((resolve) => {
            setInterval(() => {
                if (!state.isLoading)
                    resolve(true);
            }, 100);
        });
        return state.chartOfAccounts?.filter((account) => {
            return !type || account.type === type;
        });
    }
    getLedgerAccounts();
    return {
        state,
        getLedgerAccounts
    };
}
export default useLedgerStore;
